import { Icon, IconButton, Tooltip } from "@mui/material";

interface TourHelpButtonProps {
  onClick: (event?: React.MouseEvent) => void;
  tooltip?: string;
  color?: "inherit" | "dark" | "light";
}

export default function TourHelpButton({ tooltip, onClick, color = "dark" }: TourHelpButtonProps) {
  return (
    <Tooltip title={tooltip}>
      <IconButton
        onClick={onClick}
        size="small"
        sx={{
          color: color === "light" ? "rgba(255, 255, 255, 0.85)" : undefined,
          "&:hover": color === "light" ? { color: "#fff" } : undefined,
        }}
      >
        <Icon>help_outline</Icon>
      </IconButton>
    </Tooltip>
  );
}
